import $ from 'jquery';
class User {
    constructor(){
        if ($("#profile_club").length != 0){
            this.events();
        }
    }

    events() {
        //  Register Listeners only if on page
        $("#validation-club").on("change", this.clubSelected.bind());
        $("#validation-school").on("change", this.schoolSelected.bind());
        $("#validation-address").on("change", this.addressSelected.bind());
        $("#validation-guest").on("change", this.guestSelected.bind());
    }

    clubSelected(){
        setRadios(1);
    }
    schoolSelected(){
        setRadios(2);
    }
    addressSelected(){
        setRadios(4);
    }
    guestSelected(){
        setRadios(8);
    }
}
function setRadios(radio){
    if ((radio & 1) == 1){
        $("#club-data").removeClass('d-none');
    } else {
        $("#club-data").addClass('d-none');
    }
    if ((radio & 2) == 2) {
        $("#school-data").removeClass('d-none');
    } else {
        $("#school-data").addClass('d-none');
    }
    if ((radio & 4) == 4) {
        $("#address-data").removeClass('d-none');
    } else {
        $("#address-data").addClass('d-none');
    }
    if ((radio & 8) == 8) {
        $("#guest-data").removeClass('d-none');
    } else {
        $("#guest-data").addClass('d-none');
    }
}
export default User;